export var usePersonAccountValidation = function (_a) {
    var cardsOnlyLimit = _a.cardsOnlyLimit, onlyCreditCard = _a.onlyCreditCard, setOpenAlert = _a.setOpenAlert, setAlertMessage = _a.setAlertMessage;
    var validatePersonAccounts = function (accounts) {
        var rules = [
            {
                enabled: cardsOnlyLimit,
                isValid: function () { var _a; return (_a = accounts === null || accounts === void 0 ? void 0 : accounts.some(function (a) { return a.category === "MAS_LIMITE"; })) !== null && _a !== void 0 ? _a : false; },
                message: "Este cliente no cuenta con tarjeta más límite activa para asegurar.",
            },
            {
                enabled: onlyCreditCard,
                isValid: function () { var _a; return (_a = accounts === null || accounts === void 0 ? void 0 : accounts.some(function (a) { return a.type === "CREDIT_CARD"; })) !== null && _a !== void 0 ? _a : false; },
                message: "Este cliente no cuenta con tarjeta de crédito activa para asegurar.",
            },
        ];
        for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
            var rule = rules_1[_i];
            if (rule.enabled && !rule.isValid()) {
                setAlertMessage(rule.message);
                setOpenAlert(true);
                return;
            }
        }
    };
    return { validatePersonAccounts: validatePersonAccounts };
};
